module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"SmartHead AI Lab","short_name":"AI Lab","description":"SmartHead AI Lab подключается как Chief AI Officer для компаний от 100 до 1500 сотрудников: проводим AI-диагностику, запускаем пилоты и масштабируем AI-решения.","start_url":"/","background_color":"#0c101d","theme_color":"#0c101d","display":"standalone","icon":"src/assets/images/favicon.svg","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"66e3364bbd04b3c654c8e026e466ee04"},
    },{
      plugin: require('../node_modules/gatsby-plugin-google-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingIds":["G-9R9GE3L6VB"],"pluginConfig":{"head":true}},
    },{
      plugin: require('../gatsby-browser.ts'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
